import React from 'react';
import { Link } from 'react-router-dom';
import './CSS/AvisoLegal.css';

const AvisoLegal = () => {
  return (
    <div className="legal-page-container">
      <div className="legal-page-content">
        <h1>Aviso Legal</h1>

        <section className="legal-section">
          <p>
            De conformidad con la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico, le informamos que esta web es titularidad de:
          </p>
          <ul className="legal-info-list">
            <li><strong>Identidad:</strong> INTO REALITY (en adelante "EL TITULAR")</li>
            <li><strong>CIF:</strong> B67794503</li>
            <li><strong>Domicilio:</strong> Lepant 270 de Barcelona (08480)</li>
            <li><strong>Teléfono:</strong> 629332801</li>
            <li><strong>Correo electrónico:</strong> <a href="mailto:intoreality@intoreality.tv">intoreality@intoreality.tv</a></li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Propiedad Intelectual e Industrial</h2>
          <p>
            Los contenidos de este sitio, incluyendo los textos, imágenes y diseños gráficos, pertenecen a EL TITULAR, o a terceros que han autorizado su uso. EL TITULAR presenta estos contenidos con fines de información y promoción. EL TITULAR autoriza su utilización exclusivamente con estas finalidades. Cualquier utilización de estos diseños, imágenes o textos deberá citar expresamente su pertenencia a EL TITULAR, quien se reserva el derecho a iniciar las acciones legales oportunas para reparar los daños.
          </p>
        </section>

        <section className="legal-section">
          <h2>Exclusión de Responsabilidad</h2>
          <p>
            EL TITULAR actúa con la máxima diligencia posible para que los datos y la información que ofrece en su sitio web esté actualizada en todo momento, si bien no garantiza ni se hace responsable de la exactitud y actualización de los contenidos del sitio web, reservándose el derecho a modificar dichos contenidos en cualquier momento. EL TITULAR tampoco será responsable de la información que se pueda obtener a través de enlaces incluidos en el sitio web.
          </p>
          <p>
            Las relaciones comerciales con los clientes se regirán por las Condiciones Generales que, en su caso, se establezcan por EL TITULAR en un documento específico a tal efecto, o por los pactos concretos que pudieran acordarse con los clientes.
          </p>
        </section>

        <section className="legal-section">
          <h2>Condiciones de Uso</h2>
          <p>
            El uso de este sitio web implica la aceptación plena de los términos del presente aviso legal. Los posibles conflictos relativos a esta web se regirán exclusivamente por el derecho del Estado Español. Toda persona usuaria de la web, independientemente de la jurisdicción territorial desde la cual se produzca su acceso, acepta el cumplimiento y respeto de estas cláusulas con renuncia expresa a cualquier otro fuero que pudiera corresponderle, sin perjuicio de los derechos que legalmente correspondan al usuario, en caso de que este ostente la condición de consumidor.
          </p>
        </section>

        <div className="legal-back-link">
          <Link to="/">Volver al Inicio</Link>
        </div>
      </div>
    </div>
  );
};

export default AvisoLegal;
